import styled from "@emotion/styled"

import { OneLinkScriptProvider } from "contexts/OneLinkScript"
import ScrollProviderMobile from "pazChargeComponents/general/ScrollProviderMobile"
import colors from "theme/colors"
import { Desktop, ImageContainer, NewText } from "ui"
import { getNonUmbracoURL } from "utils/utils"
import { extractProperty } from "../../../../packages/ui/Brands"
import { TitleWithLine } from "../../../../packages/ui/TitleWithLine/TitleWithLine"
import BenefitsCardCharge from "./BenefitsCharge"
import QRCodeInHomePage from "./QRCodeHome"

type Props = {
    data: any
}

const StyledGrid = styled.div`
position: relative;
// overflow: hidden;
    &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: calc(100% + 300px);
        height: 85%;
       background: linear-gradient(351.79deg, rgba(21, 62, 105, 0.06) 85.73%, rgba(21, 62, 105, 0) 102.96%);
        z-index: -1; /* Place the pseudo-element behind the content */
    }
    ${(props) => props.theme.breakpoints.up("md")} {
      padding-top: 40px;
      padding-bottom: 40px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
    }
`
const StyledGridInner = styled.div`
display: flex;
     ${(props) => props.theme.breakpoints.up("md")} {
        gap: 30px;
    }
    ${(props) => props.theme.breakpoints.down("md")} {
       flex-direction: column-reverse;
    }
`
const StyledTextWrapper = styled.div`
    width: 648px;
    ${(props) => props.theme.breakpoints.between("md", "lg")} {
        padding: 20px;
        width: 590px;
    }
     ${(props) => props.theme.breakpoints.down("md")} {
         padding-top: 20px;
         padding-bottom: 20px;
        width: 100%;
    }
    // text-align: left;
`

const StyledText = styled(NewText)`
    padding-top: 10px;
    padding-bottom: 20px;
`


const StyledImageWrapper = styled.div`
padding: 20px;
     ${(props) => props.theme.breakpoints.down("md")} {
        padding: 0px;
        padding-top: 30px;
           }
`

const StyledBenefitWrapper = styled.div`
padding-top: 20px;
display: grid;
grid-template-columns: repeat(2, 1fr);
grid-auto-rows: minmax(0, 1fr);
z-index: 5;
gap: 10px;
`
const StyledWrapper = styled.div`
    padding-left: 20px;
    padding-right: 20px;
${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 100px;
    padding-right: 0px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 300px;
  }
`
export const HeroOneImage = ({ data }: Props) => {

    const desktopImage = extractProperty(data, "desktopImage")
    const mobileImage = extractProperty(data, "mobileImage")
    const title = extractProperty(data, "title")
    const subTitle = extractProperty(data, "subTitle")
    const benefits = extractProperty(data, "benefits")

    return (
        <StyledGrid>
            <StyledWrapper>
                <StyledGridInner>
                    <StyledTextWrapper>
                        <TitleWithLine
                            title={title}
                            largeDesktopFontSize={48}
                            largeDesktopLineHeight="50px"
                            desktopFontWeight={500}
                            titleFontSize={48}
                            smallDesktopFontSize={48}
                            desktopLineHeight="50px"
                            titleColor={colors.black}
                            mobileLineHeight="32px"
                            mobileTitleFontSize={28}
                            component={"h1"}
                        />
                        <StyledText
                            component={"p"}
                            largeDesktopFontSize={18}
                            largeDesktopLineHeight="20px"
                            desktopFontSize={18}
                            desktopLineHeight={"20px"}
                            mobileFontSize={16}
                            mobileLineHeight="18px"
                            color={colors.black}
                        >
                            {subTitle}
                        </StyledText>

                        <Desktop>
                            <OneLinkScriptProvider>
                                <QRCodeInHomePage />
                            </OneLinkScriptProvider>
                        </Desktop>
                        <ScrollProviderMobile adjustPositionInContainer />
                        <StyledBenefitWrapper>
                            {benefits.map((benefit: any, index: number) => {
                                const benefitsTitle = extractProperty(benefit, "title")
                                const icon = extractProperty(benefit, "icon")
                                const description = extractProperty(benefit, "description")
                                return (
                                    <BenefitsCardCharge key={index} index={index} {...{ title: benefitsTitle, icon, description }} />
                                )
                            })}

                        </StyledBenefitWrapper>

                    </StyledTextWrapper>
                    <StyledImageWrapper>
                        <ImageContainer
                            desktopUrl={getNonUmbracoURL(desktopImage)}
                            mobileUrl={getNonUmbracoURL(mobileImage)}
                            height={562}
                            width={628}
                            mediumWidth={460}
                            mediumHeight={458}
                            mobileHeight={355}
                            emptyAlt
                            fill
                            priority
                        ></ImageContainer>
                    </StyledImageWrapper>
                </StyledGridInner>
            </StyledWrapper>
        </StyledGrid>
    );
}

export default HeroOneImage;
